import type { TableColumnsType } from "antd";
import { opportunityApi } from "api/opportunity.api";
import { AppTable } from "components/antd-ui";
import { CodeCell, StatusCell, TableContent } from "components/table";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Opportunity } from "types/opportunity";
import { QUOTE_PATH, formatMoney, quoteStatusTrans } from "views/Opportunity/opportunity.meta";
import { useCustomerList } from "./useCustomerList";

// Tab "Báo giá": đã duyệt báo giá, chưa chốt đơn (gồm cả Thất bại) — hiển thị trạng thái với khách.
// Báo giá đã chốt đơn được backend loại ra (đã thành Đơn hàng)
export const CustomerQuoteTab = ({ customerId }: { customerId: number }) => {
  const navigate = useNavigate();

  const fetcher = useCallback(async (params: Record<string, unknown>) => {
    const res = await opportunityApi.findAll({ ...params, hasQuote: "true", countScope: "quote" });
    return { items: (res.data.opportunitys || []) as Opportunity[], total: res.data.total || 0 };
  }, []);

  const { items, loading, pagination } = useCustomerList<Opportunity>(customerId, fetcher);

  const columns = useMemo<TableColumnsType<Opportunity>>(
    () => [
      { title: "Mã báo giá", dataIndex: "code", key: "code", width: 140, render: (value) => <CodeCell value={value || "--"} /> },
      { title: "Tên", dataIndex: "name", key: "name", render: (value) => <TableContent>{value || "--"}</TableContent> },
      {
        title: "Trạng thái",
        dataIndex: "quoteStatus",
        key: "quoteStatus",
        width: 170,
        render: (value) => <StatusCell value={value} trans={quoteStatusTrans} />,
      },
      {
        title: "Tổng tiền",
        dataIndex: "totalAmount",
        key: "totalAmount",
        width: 150,
        align: "right",
        render: (value: number) => formatMoney(value || 0),
      },
      {
        title: "Lý do thất bại",
        dataIndex: "failReason",
        key: "failReason",
        render: (value) => <TableContent>{value || "--"}</TableContent>,
      },
    ],
    [],
  );

  return (
    <AppTable<Opportunity>
      className="customerTabTable"
      rowKey="id"
      size="small"
      loading={loading}
      dataSource={items}
      columns={columns}
      pagination={pagination}
      locale={{ emptyText: "Chưa có báo giá" }}
      onRow={(record) => ({ onClick: () => navigate(`${QUOTE_PATH}/${record.id}`) })}
    />
  );
};
